









































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import SeeMoreTextLink from "@/common/components/atoms/SeeMoreTextLink.vue";
import IconTrophy from "@/common/components/icons/IconTrophy.vue";

import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";

import { getGrantCriteriaList, getUserProfile } from "@/general/store/api";
import { mapState } from "vuex";
import { UserInfo } from "@/general/store/models";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import AuthApi from "@/general/api/authApi";
import IconUserRank from "@/common/components/icons/IconUserRank.vue";
import { getThanksPointName, getThanksOnlyPointName } from "@/common/assets/js/utils/pointName";

@Component({
  name: "TheH01ProfilePanel",
  components: {
    IconUserImage,
    IconBase,
    IconArrowBottom,
    IconInvestedRounded,
    PointNotation,
    IconTrophy,
    IconUserRank,
    SeeMoreTextLink
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class TheH01ProfilePanel extends Vue {
  shownPointStatus = false;

  point: any = {};
  userInfo: UserInfo = {} as UserInfo;
  conditions: Array<any> = [];
  currentPage!: number;
  storeColorCode: string;

  get fullName() {
    return commons.getNameFromUser(commons.userInfo);
  }

  get iconSize() {
    const resultSize: any = {
      true: 48,
      false: 80
    };

    return resultSize; //[this.isSp];
  }

  get unit() {
    return commons?.unit;
  }

  get isSp() {
    return globals?.isLargeBreakpointWidthOfSp;
  }

  get pageSize() {
    return 2; // commons?.pageSize ? commons.pageSize : 10;
  }

  get pointNotationStyle() {
    const pointNotationStyle = {
      sp: {
        fontSize: 28
      },
      pc: {
        fontSize: 48
      }
    };
    const index = globals.isLargeBreakpointWidthOfSp ? "sp" : "pc";

    return pointNotationStyle[index];
  }

  get internalShownPointStatus() {
    const { shownPointStatus } = this;
    return shownPointStatus;
  }

  set internalShownPointStatus(newValue: any) {
    if (this.shownPointStatus !== newValue) {
      this.shownPointStatus = newValue;
    }
  }

  get urlGrantCriteria() {
    return CONST_DATA.SITE_MAP.GRANT_CRITERIA;
  }

  get urlExpiring() {
    return CONST_DATA.SITE_MAP.EXPIRING_POINTS;
  }

  get ShowKenko() {
    return auth.user.kenko;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get groupBudgetStyle() {
    if(this.isGroupBudget) {
      return {marginTop: '0px'}
    }
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

  @Watch("isSp")
  onIsSp() {
    this.switchPointStatus();
  }

  switchPointStatus() {
    const { isSp } = this;
    this.shownPointStatus = !isSp;
  }

  get thanksPointEnabled() {
    return auth.user?.thanks_point_enabled;
  }

  get thanksExclusiveEnabled() {
    // const orgAdminSettings = LocalStorage.getItem("orgAdminSettings")
    //   ? JSON.parse(LocalStorage.getItem("orgAdminSettings") as string)
    //   : [];
    // if (
    //   orgAdminSettings &&
    //   orgAdminSettings.length > 0 &&
    //   orgAdminSettings[0] &&
    //   orgAdminSettings[0].thanks_exclusive_points_enabled
    // ) {
    //   return true;
    // }

    // return false;

    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      return userDetailsJson.thanks_exclusive_points_enabled;
    }
    return false;
  }

  get link() {
    return `${CONST_DATA.SITE_MAP.EXPIRED_POINTS}`;
  }

  get commonUserInfo(){
    return commons?.userInfo
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  get thanksOnlyPointName() {
    return getThanksOnlyPointName(CONST_DATA.POINT_NAME.THANKS_ONLY_POINT_DEFAULT_NAME1);
  }

  async created() {
    this.shownPointStatus = !globals.isLargeBreakpointWidthOfSp;

    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);

    const pageParam = urlParams.get("page");
    this.currentPage = 1; // pageParam ? parseInt(pageParam) : 1;

    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.userInfo = ic_session;
    })
    .catch(() => {
      this.userInfo = auth.user;
    });

    const response = await getGrantCriteriaList(
      "",
      this.currentPage,
      this.pageSize,
      ""
    );
    this.conditions = response.results || [];

    this.point = await getUserProfile("");
    this.shownPointStatus = true;
  }
}
